import React from 'react'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import PaymentProfiles from '../components/PaymentProfiles'

export default function PaymentProfilesPage() {
  return (
    <LayoutBase>
      <LayoutMain>
        <PaymentProfiles />
      </LayoutMain>
    </LayoutBase>
  )
}
